import React from "react";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import { Button, ButtonVariant } from "components/buttons/Button";
import { DestinationLogo } from "../DestinationLogo";
import styles from "./index.module.scss";
import { PlatformId } from "views/page-content/platforms/types";

export interface DestinationDisplayAction {
    type: ButtonVariant;
    onClick: (destination: DestinationDescriptor) => void;
    element: React.ReactElement;
}

export interface DestinationDisplayProps {
    destinations: DestinationDescriptor[];
    actions?: DestinationDisplayAction[];
}

export const DestinationDisplay = ({
    destinations,
    actions = []
}: DestinationDisplayProps) => {
    if (!destinations || !destinations.length) {
        return null;
    }

    return (
        <ul className={styles["selected-destinations"]}>
            {destinations
                // Don't show Player (it's covered in CatalogDestination)
                .filter((d) => d.platform !== PlatformId.VideoPlayer)
                .map((destination, i) => {
                    return (
                        <li key={i} className={styles["selected-destination"]}>
                            <DestinationLogo destination={destination} />
                            <div>
                                <p>{destination.name}</p>
                                <small>
                                    {
                                        destination.platformSpecificSettings
                                            ?.selectedPrivacy
                                    }
                                </small>
                            </div>
                            {actions.map((action, index) => {
                                if (
                                    destination.platform === PlatformId.Rtmp &&
                                    index === 0
                                ) {
                                    // Skip edit action for RTMP destinations
                                    return null;
                                }

                                return (
                                    <Button
                                        key={index}
                                        type={action.type}
                                        onClick={() =>
                                            action.onClick(destination)
                                        }
                                    >
                                        {action.element}
                                    </Button>
                                );
                            })}
                        </li>
                    );
                })}
        </ul>
    );
};
